export const TOGGLE_THEME = 'toggle_theme';
export const SET_AUTH_USER = 'set_auth_user';
